/**
 * Angular JS APP
 */
angular.module('brimarex-theme', [
  'ui.bootstrap',
  'checklist-model'
])

/**
 * Config
 */
.config(['$locationProvider', '$httpProvider', function($locationProvider, $httpProvider) {
  /**
   * LocationProvider config
   */
  $locationProvider
    .html5Mode({
      enabled: true,
      requireBase: false,
      rewriteLinks: false
    });
  
  /**
   * HttpProvider config
   */
  $httpProvider.interceptors.push(['$q', function ($q) {
    return {
      request: function(config) {
        /**
         * Abort request
         */
        if (!config.timeout) {
          config.cancel  = $q.defer();
          config.timeout = config.cancel.promise;
        }

        return config;
      }
    }
  }]);
}])

/**
 * App run
 */
.run(['$rootScope', '$http', function($rootScope, $http) {
  /**
   * Abort $http pending requests on location change
   */
  $rootScope.$on("$locationChangeStart", function(event, next, current) {
    for (var i=0; i < $http.pendingRequests.length - 1; i++) {
      var request = $http.pendingRequests[i];

      if (request.cancel)
        request.cancel.resolve('Cancel!');
    }
  });
}])

/**
 * AppController
 */
.controller('AppController', ['$rootScope', function($rootScope) {
  $rootScope.config = brThemeConfig;

  /**
   * Form submit
   * 
   * @param {Angular form} form
   * @param {Event} event
   * @return {boolean}
   */
  $rootScope.formSubmit = function(form, event) {
    form.$submitted = true;
    if (form.$invalid) {
      event.preventDefault();
      return false;
    }

    return true;
  }
}])

/**
 * Authentication Controller
 */
.controller('AuthenticationController', ['$scope', '$http', function($scope, $http) {
  /**
   * Login
   * 
   * @param {Angular form} form
   * @param {Event} event
   */
  $scope.login = function(form, event) {
    var submitted = $scope.formSubmit(form, event);

    if (submitted) {
      $scope.loginForm.pending = true;
      $scope.loginForm.validations = [];
      $scope.loginForm.messages = {
        type: '',
        message: '',
        validation: []
      };

      $http({
        method: 'POST',
        url: $scope.config.site_url +'/wp-admin/admin-ajax.php?action=user_login',
        data: $scope.loginForm.data
      }).then(function(response) {
        $scope.loginForm.pending = false;
        $scope.loginForm.messages.type = 'success';
        $scope.loginForm.messages.message = response.data.message;

        location.href = response.headers('Location');
      }, function(response) {
        $scope.loginForm.pending = false;
        $scope.loginForm.messages.type = 'danger';
        $scope.loginForm.messages.message = response.data.message;

        if (typeof response.data.validation != 'undefined')
          $scope.loginForm.validations = response.data.validation;
      });
    }
    return false;
  }

  /**
   * Register
   * 
   * @param {Angular form} form
   * @param {Event} event
   */
  $scope.register = function(form, event) {
    var submitted = $scope.formSubmit(form, event);

    if (submitted) {
      $scope.registerForm.pending = true;
      $scope.registerForm.validations = [];
      $scope.registerForm.messages = {
        type: '',
        message: '',
        validation: []
      };

      $http({
        method: 'POST',
        url: $scope.config.site_url +'/wp-admin/admin-ajax.php?action=user_register',
        data: $scope.registerForm.data
      }).then(function(response) {
        $scope.registerForm.pending = false;
        $scope.registerForm.messages.type = 'success';
        $scope.registerForm.messages.message = response.data.message;
      }, function(response) {
        $scope.registerForm.pending = false;
        $scope.registerForm.messages.type = 'danger';
        $scope.registerForm.messages.message = response.data.message;

        if (typeof response.data.validation != 'undefined')
          $scope.registerForm.validations = response.data.validation;
      });
    }
    return false;
  }
}])

/**
 * Woocommerce products list Controller
 */
.controller('WoocommerceProductListController', ['$scope', '$location', '$timeout', '$http', function($scope, $location, $timeout, $http) {
  /**
   * Declare filter change subscribe
   * 
   * @var {undefined}
   */
  $scope.filtersChangeSubscribe;

  /**
   * Declare protected filters
   * 
   * @var {array}
   */
  $scope.filtersProtected = [
    'limit',
    'sort',
    'phrase'
  ];

  /**
   * Declare array filters
   */
  $scope.filtersArray = [
    'brand',
    'license'
  ];

  /**
   * Declare results
   * 
   * @var {object}
   */
  $scope.results = {
    init: true,
    pending: false
  }

  /**
   * Pagination
   */
  $scope.pagination;

  /**
   * Getter filters
   */
  $scope.getFilters = function() {
    filters = $location.search();

    angular.forEach(filters, function(value, key, obj) {
      if ($scope.filtersArray.indexOf(key) != -1)
        filters[key] = decodeURI(filters[key]).split(',');
    });

    return filters;
  }

  /**
   * Declare filters
   * 
   * @var {object}
   */
  $scope.filters = $scope.getFilters();

  /**
   * Search
   * 
   * @param {Angular form} form
   * @param {Event} event
   */
  $scope.search = function(form, event) {
    $scope.searchForm.pending = true;
    
    $scope.filterClear();
    $scope.filterChange('phrase', $scope.searchForm.data.phrase);
  }

  /**
   * Filters checked
   * 
   * @param {string} type
   * @param {string} value
   * @return {boolean}
   */
  $scope.filtersChecked = function(type, value) {
    return $scope.filters[type].indexOf(value) != -1
  }

  /**
   * Filter change
   * 
   * @param {string} type (optional)
   * @param {int} id (optional)
   * @param {Event} event (optional)
   */
  $scope.filterChange = function(type, id, event) {
    $scope.filters.page = 1;

    if (typeof event != 'undefined')
      event.preventDefault();

    if (typeof type != 'undefined' && typeof id != 'undefined')
      $scope.filters[type] = id;
  }

  /**
   * Filter clear
   * 
   * @param {string} type (optional)
   * @param {Event} event (optional)
   */
  $scope.filterClear = function(type, event) {
    if (typeof event != 'undefined')
      event.preventDefault();

    // CLear all filters
    if (typeof type == 'undefined')
      angular.forEach($scope.filters, function(value, key, obj) {
        if ($scope.filtersProtected.indexOf(key) === -1)
          obj[key] = "";
      });
    
    // Clear specific filter
    else if (typeof $scope.filters[type] !== 'undefined')
      $scope.filters[type] = "";
  }

  /**
   * Watch filters change.
   */
  $scope.$watch('filters', function(newValue, oldValue) {
    if ($scope.results.init) {
      $scope.results.init = false;
      return;
    }

    if (!Object.keys(newValue).length && !Object.keys(oldValue).length)
      return;

    // Cancel promise
    if ($scope.filtersChangeSubscribe)
      $timeout.cancel($scope.filtersChangeSubscribe);
    
    // Set promise
    $scope.filtersChangeSubscribe = $timeout(function() {
      $scope.results.pending = true;
      var filters = angular.extend({}, $scope.filters);

      // Prepare params from filters
      angular.forEach(filters, function(value, key, obj) {
        if (Array.isArray(value))
          obj[key] = value.join();

        if (value.length == 0) {
          delete obj[key];
          delete $scope.filters[key];
        }
      });

      // Set url params
      $location.search(filters);

      // Set template
      filters['template'] = 'archive-product-results';
      
      // Get results
      $http({
        method: 'GET',
        url: $scope.config.current_url +'/',
        params: filters
      }).then(
        function(response) {
          angular.element('.woocommerce-products-results')
            .html(response.data);

          $scope.pagination = JSON.parse(response.headers('Pagination'));
          $scope.results.pending = false;
        },
        function(response) {
          if (response.status !== -1)
            $scope.results.pending = false;
        }
      );
    }, 450);
  }, true);

  $scope.$watch('results.pending', function(newValue, oldValue) {
    if (newValue === false)
      $scope.searchForm.pending = false;
  }, true)
}])

/**
 * Woocommerce product Controller
 */
.controller('WoocommerceProductController', ['$scope', function($scope) {

}])

/**
 * Menu target
 */
.directive('menuTarget', ['$timeout', function($timeout) {
  return{
    restrict: 'A',
    link: function(scope, element, attr) {
      $timeout(function() {
        var button = element,
            target = angular.element(attr.menuTarget);

        if (!target.length)
          return;
        
        target.addClass('menu-target');

        // onClick event
        button.on('click', function(e) {
          e.preventDefault();
          target.toggleClass('menu-target-open');
        });
      });
    }
  }
}])

/**
 * Sticky
 */
.directive('sticky', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      $timeout(function() {
        var container = element.parent(),
            options = element.data('sticky-options') || {};

        $(window).on('scroll load resize touchmove', function() {
          var wind = $(this),
              elem_parent_fix = element,
              elem_fix = elem_parent_fix.data('sticky'),
              elem_fix = angular.element(elem_fix, elem_parent_fix),
              offset = (
                (options.offsetElement
                  ? angular.element(options.offsetElement).outerHeight()
                  : 0
                ) + (options.offset || 0)    
              );

          if (elem_fix.length) {
              var elem_parent_fix_position_top = elem_parent_fix.offset().top + parseInt(elem_parent_fix.css('padding-top')) - parseInt(elem_parent_fix.css('margin-top')) - offset,
                  elem_parent_fix_position_bottom = elem_parent_fix.offset().top + elem_parent_fix.innerHeight() - parseInt(elem_parent_fix.css('padding-top'));

              if ((wind.scrollTop() + parseInt(wind.innerHeight())) > elem_parent_fix_position_bottom && wind.scrollTop() >= elem_parent_fix_position_top) {
                  elem_parent_fix.addClass('fix-to-top');
                  elem_fix
                    .addClass('fix-to-top-bottom')
                    .css({
                      position: 'absolute',
                      top: '',
                      bottom: 0,
                      width: elem_parent_fix.outerWidth()
                    });;

                  elem_fix.removeClass('fix-to-top-fixed');
              } else if (wind.scrollTop() >= elem_parent_fix_position_top) {
                  elem_parent_fix.addClass('fix-to-top');
                  elem_fix
                    .addClass('fix-to-top-fixed')
                    .css({
                      position: 'fixed',
                      top: offset,
                      bottom: '',
                      width: elem_parent_fix.outerWidth()
                    });

                  elem_fix.removeClass('fix-to-top-bottom');
              } else {
                  elem_parent_fix.removeClass('fix-to-top');
                  elem_fix
                    .removeClass('fix-to-top-fixed')
                    .css({
                      position: '',
                      top: '',
                      bottom: '',
                      width: ''
                    });;
              }
          }
        });
      });
    }
  }
}])

/**
 * Product gallery directive
 */
.directive('woocommerceProductGallery', ['$timeout', function($timeout) {
  return {
    restrict: 'C',
    link: function (scope, element, attrs) {
      $timeout(function() {
        var mainWrap = angular.element('.woocommerce-product-gallery__image-main', element),
            mainNav = angular.element('nav', mainWrap),
            thumbnailsWrap = angular.element('.woocommerce-product-gallery__thumbnails', element);

        // Thumbnails
        if (thumbnailsWrap.length) {
          var thumbnails = angular.element('.woocommerce-product-gallery__image a', thumbnailsWrap);
          
          // Navigation
          if (mainNav.length) {
            if (!thumbnails.length)
              mainNav.remove();

            else {
              var mainNavLink = angular.element('a', mainNav);

              // Navigation link
              mainNavLink.on('click', function(e) {
                e.preventDefault();
                var button = angular.element(this),
                    activeImage = thumbnails.filter('.active').parents('.woocommerce-product-gallery__image'),
                    prevImage = activeImage.index() <= 0
                      ? thumbnails.length - 1
                      : parseInt(activeImage.index()) - 1;
                    nextImage = activeImage.index() == thumbnails.length - 1
                      ? 0
                      : parseInt(activeImage.index()) + 1;
                
                thumbnails
                  .removeClass('active')
                  .eq(
                    button.hasClass('prev')
                      ? prevImage
                      : nextImage
                  )
                  .addClass('active')
                  .click();
              })
            }
          }

          // On click event
          thumbnails.on('click', function(e) {
            e.preventDefault();

            var link = angular.element(this),
                image = angular.element('img', link);

            var mainLink = angular.element('> a', mainWrap),
                mainImage = angular.element('img', mainLink);

            mainLink
              .attr('href', link.attr('href'));
            mainImage
              .attr('src', image.data('shop_single'));

            thumbnails.removeClass('active');
            link.addClass('active');
          });
        }
      });
    }
  }
}]);